import { render, staticRenderFns } from "./iq-card.vue?vue&type=template&id=7bd72b2e"
import script from "./iq-card.vue?vue&type=script&lang=js"
export * from "./iq-card.vue?vue&type=script&lang=js"
import style0 from "./iq-card.vue?vue&type=style&index=0&id=7bd72b2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports